export default __webpack_public_path__ + "static/media/img11.255d9a97.jpg";